/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { loginApi } from '../../setup/setupApi';
import { Audience, MailchimpConnect, MergeTag } from './types';

// Mailchimp requests

export const getMailchimp = (projectId: string): Promise<Audience> =>
  loginApi.get(`projects/${projectId}/mailchimp`).then((res) => res.data);

export const getMailchimpAudience = (projectId: string, apiKey: string): Promise<Audience[]> =>
  loginApi
    .get(`projects/${projectId}/mailchimp/lists`, {
      headers: { 'X-Mailchimp-Api-Key': encodeURIComponent(apiKey.trim()) }
    })
    .then((res) => res.data);

export const connectMailchimp = (projectId: string, values: MailchimpConnect) =>
  loginApi.post(`projects/${projectId}/mailchimp/lists`, values).then((res) => res.data);

export const disconnectMailchimp = (projectId: string) =>
  loginApi.delete(`projects/${projectId}/mailchimp`);

export const getMailchimpMergeTags = (projectId: string): Promise<MergeTag[]> =>
  loginApi.get(`projects/${projectId}/mailchimp_merge_tags`).then((res) => res.data);

export const postMailchimpMergeTags = (
  projectId: string,
  mailchimpListId: string,
  values: MergeTag[]
): Promise<boolean> =>
  loginApi
    .post(`projects/${projectId}/mailchimp_merge_tags?${`list_id=${mailchimpListId}`}`, values)
    .then((res) => true);
